import React, { useEffect, useState } from "react";
import { MyGroup } from "@/features/my-data/components/my-group";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useGetAccountGroups } from "@/features/accounts/account-group/hooks/use-get-account-groups"
import { Header } from "@/features/home/components/header"
import { Sidebar } from "@/features/home/components/side-bar"
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { ShareMemberModal } from "@/features/my-data/components/share-member-modal";
import { ShareAccountGroupModal } from "@/features/my-data/components/share-account-group-modal";
import { SendShareMailModal } from "@/features/my-data/components/send-share-mail-modal";
import { useTradeJumpContext } from "@/features/trade-jump/contexts/trade-jump-context";
import { GroupMenuModal } from "@/features/my-data/components/group-menu-modal";
import { useLocation } from "react-router-dom";
import { useGetAccountGroupsShareInvited } from "@/features/accounts/account-group/hooks/use-get-account-groups-share-invited";
import { InvitedGroupModal } from "@/features/accounts/account-group/components/invited-group-modal";
import { InvitationNavigation } from "@/features/my-data/components/invitation-navigation";
import { ShareMemberCancelConfirmModal } from "@/features/my-data/share-member-cancel-confirm-modal";
import { useShareAccountGroup } from "@/features/my-data/hooks/use-share-account-group";
import { useLoginContext } from "../auth/contexts/login-context";


export const MyData = () => {
  const [pendingDeleteMemberId, setPendingDeleteMemberId] = useState<string | undefined>(undefined);
  const [pendingDeleteMemberMail, setPendingDeleteMemberMail] = useState<string | undefined>(undefined);
  const [pendingCancelType, setPendingCancelType] = useState<"share" | "invite" | undefined>(undefined);

  const {
    soriId,
  } = useLoginContext();
  const {
    accountGroups,
    targetAccountGroup,
    invitedAccountGroups,
    setSelectedAccount,
    resetTargetAccountGroup,
  } = useAccountGroupsContext();
  const {
    openMyDataModal,
    setOpenHomeModal,
    setOpenMyDataModal,
  } = useModalContext();
  const {
    getAccountGroups,
  } = useGetAccountGroups();
  const {
    syncJump,
  } = useTradeJumpContext();
  const { getAccountGroupsShareInvited } = useGetAccountGroupsShareInvited();
  const location = useLocation();
  const { updateShareMembers } = useShareAccountGroup({ onTapCompleteModal: () => {} });

  useEffect(() => {
    setOpenHomeModal(undefined);
    setOpenMyDataModal(undefined);
    getAccountGroups(true);
  }, [soriId, syncJump]);

  // 共有招待されている口座グループ情報の取得
  useEffect(() => {
    if (syncJump || syncJump === undefined) return;
    getAccountGroupsShareInvited();
  }, [soriId, syncJump]);
  
  // 招待されている口座グループが更新された際の処理
  useEffect(() => {
    if (syncJump) return;
    if (invitedAccountGroups.length === 0) return;
    if (location.search) return;
    if (openMyDataModal) return;
    setOpenMyDataModal("ShareInvited");
  }, [invitedAccountGroups, syncJump]);

  const openCancelConfirm = (memberId: string, cancelType: "share" | "invite", targetMail: string) => {
    setPendingDeleteMemberId(memberId);
    setPendingDeleteMemberMail(targetMail);
    setPendingCancelType(cancelType);
    setOpenMyDataModal("ShareMemberCancelConfirm");
  };

  const closeCancelConfirm = () => {
    setOpenMyDataModal("ShareMember");
    setPendingDeleteMemberId(undefined);
    setPendingDeleteMemberMail(undefined);
    setPendingCancelType(undefined);
  };

  const confirmCancel = async () => {
    if (!pendingDeleteMemberId) {
      closeCancelConfirm();
      return;
    }
    await updateShareMembers(
      targetAccountGroup.accountGroupId,
      pendingDeleteMemberId,
      3  // 解除
    );
    closeCancelConfirm();
  };

  return (
    <>
      <Header
        doAction={() => {
          getAccountGroups(true);
        }}
      />
      <Sidebar />
      <InvitationNavigation />
      <main className="page_mydata">
        <header className="title">
          <h2>グループ</h2>
        </header>
        {/* リスト */}
        {accountGroups.map((item, index) => (
          <MyGroup
            key={`${item.accountGroupId}`}
            accountGroup={item}
            id={index.toString()}
          />
        ))}
      </main>

      <GroupMenuModal
        isOwner={targetAccountGroup.isOwner === 1}
        onTapCloseModal={() => {
          resetTargetAccountGroup();
          setSelectedAccount(undefined);
          setOpenMyDataModal(undefined);
        }}
      />

      {openMyDataModal === "ShareMember" && (
        <ShareMemberModal
          isOwner={targetAccountGroup.isOwner}
          onTapOpenCancelConfirm={openCancelConfirm}
          onTapCloseModal={() => {
            setOpenMyDataModal(undefined);
            getAccountGroups(true);
          }}
          onTapCompleteModal={() => {
            setOpenMyDataModal("SendShareMail");
            getAccountGroups(true);
          }}
        />
      )}

      {openMyDataModal === "ShareMemberCancelConfirm" && (
        <ShareMemberCancelConfirmModal
          cancelType={pendingCancelType}
          targetMail={pendingDeleteMemberMail}
          onTapCloseModal={closeCancelConfirm}
          onTapConfirm={confirmCancel}
        />
      )}

      {/* 共有モーダル */}
      {openMyDataModal === "Share" && (
        <ShareAccountGroupModal
          onTapCloseModal={() => {
            setOpenMyDataModal(undefined);
          }}
          onTapCompleteModal={() => {
            setOpenMyDataModal("SendShareMail");
            getAccountGroups(true);
          }}
        />
      )}

      {/* 共有招待メール送信完了モーダル */}
      {openMyDataModal === "SendShareMail" && (
        <SendShareMailModal
          onTapCloseModal={() => {
            setOpenMyDataModal(undefined);
          }}
        />
      )}

      {openMyDataModal === "ShareInvited" && (
        <InvitedGroupModal
          onTapCloseModal={() => {
            setOpenMyDataModal(undefined);
          }}
        />
      )}
    </>
  );
};
